import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { loginEndpoint } from '../api/auth-endpoints';
import { useAuthStore, fetchCurrentUser } from '../store/auth-store';

export function useLogin() {
  const setTokens = useAuthStore((s) => s.setTokens);
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) =>
      loginEndpoint(email, password),
    onSuccess: async (data) => {
      setTokens(data.access_token, data.refresh_token);
      await fetchCurrentUser();
      void navigate('/dashboard', { replace: true });
    },
  });
}
